import { api } from "./client";
import type {
  Patient,
  PatientDetail,
  CreatePatientInput,
  UpdatePatientInput,
} from "@/lib/types/patients";

interface PatientsListResponse {
  data: {
    patients: Patient[];
    total: number;
    page: number;
    pageSize: number;
  };
}

export function getPatients(params?: {
  search?: string;
  dob?: string;
  page?: number;
  pageSize?: number;
}) {
  return api.get<PatientsListResponse>("/patients", { params });
}

export function getPatient(id: string) {
  return api.get<{ data: { patient: PatientDetail } }>(`/patients/${id}`);
}

export function createPatient(data: CreatePatientInput) {
  return api.post<{ data: { patient: Patient } }>("/patients", data);
}

export function updatePatient(id: string, data: UpdatePatientInput) {
  return api.put<{ data: { patient: Patient } }>(`/patients/${id}`, data);
}

export function deletePatient(id: string, opts?: { approvalToken?: string }) {
  return api.delete(`/patients/${id}`, {
    ...(opts?.approvalToken
      ? { body: { approvalToken: opts.approvalToken } }
      : {}),
  });
}
